import { Component, Inject, OnDestroy } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { BehaviorSubject, Observable, ReplaySubject } from 'rxjs';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { finalize, takeUntil } from 'rxjs/operators';

import { ProductUnitModel } from 'projects/workspace/src/app/shared/models';
import { ProductTypes } from '../../../products/product-types';
import { CompanyProfile } from 'projects/workspace/src/app/administration/models/company-profile.model';

export type CreateUnitRequestFunction = (name: string, allowFractionalValues: boolean) => Observable<ProductUnitModel>;

@Component({
  selector: 'rnpl-create-product-type-unit-modal',
  templateUrl: './create-product-type-unit-modal.component.html',
})
export class CreateProductTypeUnitModalComponent implements OnDestroy {

  public productTypes = ProductTypes;
  public nameControl: FormControl = new FormControl(null, [Validators.required]);
  public allowFractionalValuesControl: FormControl = new FormControl(false);

  readonly destroy$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);
  readonly submitRequest$: BehaviorSubject<boolean> = new BehaviorSubject(null);

  constructor(
    public dialogRef: MatDialogRef<CreateProductTypeUnitModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      productType: ProductTypes;
      companyProfile: CompanyProfile,
      createUnitFunction$: CreateUnitRequestFunction;
    }
  ) {
    this.dialogRef.keydownEvents().subscribe(event => {
      if (event.key === 'Escape') {
        this.dialogRef.close();
      }
    });
  }

  public submit(): void {
    this.nameControl.markAsTouched();
    this.nameControl.updateValueAndValidity();

    if (this.submitRequest$.getValue() || this.nameControl.invalid) {
      return;
    }

    this.submitRequest$.next(true);

    this.data.createUnitFunction$(this.nameControl.value, this.allowFractionalValuesControl.value)
      .pipe(
        finalize(() => this.submitRequest$.next(false)),
        takeUntil(this.destroy$)
      )
      .subscribe((unit: ProductUnitModel) => this.dialogRef.close(unit));
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
